import { cn } from "../../lib/cn";

interface DialogHeaderProps {
  children: React.ReactNode;
  className?: string;
}

function DialogHeader({ children, className }: DialogHeaderProps) {
  return (
    <div className={cn("flex flex-col gap-3 p-7 pb-6", className)}>
      {children}
    </div>
  );
}

export { DialogHeader };
